import Axios from 'axios-observable';
import { IResponse } from 'interfaces';

export const updateAnalyticsColorCodes = () => {
  return Axios.post<IResponse<void>>("/reverse-color-codes");
};